var map = {
	"./decidim/avatar-multiuser.png": 76524,
	"./decidim/brands/google.svg": 1219,
	"./decidim/cc-badge.png": 76766,
	"./decidim/decidim-logo.svg": 29934,
	"./decidim/default-avatar.svg": 60218,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 44046,
	"./decidim/icons.svg": 51373,
	"./decidim/pattern.png": 21450,
	"./decidim/placeholder-card-g.svg": 34151,
	"./decidim/placeholder-card-l.svg": 28092,
	"./decidim/placeholder.jpg": 13763,
	"./decidim/remixicon.symbol.svg": 28779,
	"./decidim/vendor/leaflet/layers-2x.png": 88206,
	"./decidim/vendor/leaflet/layers.png": 54549,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 29500,
	"./decidim/vendor/leaflet/marker-icon.png": 63083,
	"./decidim/vendor/leaflet/marker-shadow.png": 4112,
	"./decidim/vendor/social-share-button/douban.svg": 81178,
	"./decidim/vendor/social-share-button/email.svg": 39831,
	"./decidim/vendor/social-share-button/facebook.svg": 39465,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 5323,
	"./decidim/vendor/social-share-button/hacker_news.svg": 1243,
	"./decidim/vendor/social-share-button/linkedin.svg": 46183,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 58880,
	"./decidim/vendor/social-share-button/pinterest.svg": 58137,
	"./decidim/vendor/social-share-button/reddit.svg": 27369,
	"./decidim/vendor/social-share-button/telegram.svg": 1232,
	"./decidim/vendor/social-share-button/tumblr.svg": 89287,
	"./decidim/vendor/social-share-button/twitter.svg": 46438,
	"./decidim/vendor/social-share-button/vkontakte.svg": 93016,
	"./decidim/vendor/social-share-button/wechat.svg": 31363,
	"./decidim/vendor/social-share-button/whatsapp.svg": 53371,
	"./decidim/vendor/social-share-button/x.svg": 45999,
	"./decidim/vendor/social-share-button/xing.svg": 45801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45187;